import { createEvent, restore, sample } from 'effector'
import { fx } from '../../../../libs'
import {
  KPISettingsItem,
  KPISettingsRequest,
  KPISettingsResponse,
} from './types'
import {
  setRequestError,
  setRequestSuccess,
} from '../../../../features/notifications'

export const kpiSettingsListMounted = createEvent<KPISettingsRequest>()

export const getKPISettings = fx<KPISettingsRequest, KPISettingsResponse>({
  method: 'GET',
  url: `/statistics/fin-kpi-common`,
})

export const $kpiSettingsList = restore<KPISettingsItem[]>(
  getKPISettings.doneData.map((a) => a.body.items),
  [],
)

export const $totalCountOfKPISettings = restore(
  getKPISettings.doneData.map((a) => a.body.total),
  0,
)

sample({
  // @ts-ignore
  clock: kpiSettingsListMounted,
  fn: ({ limit, page }) => {
    return {
      query: { limit, page },
    }
  },
  target: getKPISettings,
})

// --- Save user setting (inline edit) ---

export const saveUserSetting = createEvent<{
  id: number
  evaluation: number
  isIgnoreSpeedCounting: boolean
}>()

export const putUserSetting = fx<
  { evaluation: number; isIgnoreSpeedCounting: boolean },
  void
>({
  method: 'PUT',
  url: '/statistics/fin-kpi-user/{id}',
})

sample({
  clock: saveUserSetting,
  fn: ({ id, evaluation, isIgnoreSpeedCounting }) => ({
    url: `/statistics/fin-kpi-user/${id}`,
    body: { evaluation, isIgnoreSpeedCounting },
  }),
  target: putUserSetting,
})

sample({
  clock: putUserSetting.doneData,
  fn: () => true,
  target: setRequestSuccess,
})

sample({
  clock: putUserSetting.failData,
  fn: (failData) => ({
    message: failData.body?.message ?? 'Error',
    code: failData.status,
  }),
  target: setRequestError,
})

// --- Update managers quantity ---

export const submitUpdateManagersQuantity = createEvent<{
  id: number
  managersQuantity: number
}>()

export const updateManagersQuantity = fx<{ managersQuantity: number }, void>({
  method: 'PUT',
  url: '/statistics/fin-kpi-common/{id}',
})

sample({
  clock: submitUpdateManagersQuantity,
  fn: ({ id, managersQuantity }) => ({
    url: `/statistics/fin-kpi-common/${id}`,
    body: { managersQuantity },
  }),
  target: updateManagersQuantity,
})

sample({
  clock: updateManagersQuantity.doneData,
  fn: () => true,
  target: setRequestSuccess,
})

sample({
  clock: updateManagersQuantity.failData,
  fn: (failData) => ({
    message: failData.body?.message ?? 'Error',
    code: failData.status,
  }),
  target: setRequestError,
})
